// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Search48Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Search48: FC<Search48Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="48"
            height="48"
        >
            <path d="m39.656 41.796-13.15-13.15c-1 .867-2.166 1.542-3.498 2.025a12.37 12.37 0 0 1-4.252.725c-3.605 0-6.656-1.25-9.154-3.75-2.497-2.5-3.746-5.516-3.746-9.05 0-3.533 1.25-6.55 3.75-9.05 2.5-2.5 5.525-3.75 9.075-3.75 3.55 0 6.567 1.25 9.05 3.75 2.484 2.5 3.725 5.52 3.725 9.058 0 1.428-.233 2.81-.7 4.142a12.694 12.694 0 0 1-2.1 3.75l13.2 13.1-2.2 2.2Zm-20.95-13.4c2.709 0 5.01-.958 6.907-2.875 1.896-1.916 2.843-4.225 2.843-6.925s-.947-5.008-2.843-6.925c-1.896-1.916-4.198-2.875-6.907-2.875-2.736 0-5.061.959-6.977 2.875-1.915 1.917-2.873 4.225-2.873 6.925s.958 5.009 2.873 6.925c1.916 1.917 4.241 2.875 6.977 2.875Z" />
        </svg>
    );
};

export default Search48;
